import React, { useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect from '../../../components/DropdownSelect';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import ProductController, {
  ProductType,
  SetItemProductType,
  SetMenuItemType,
} from '../../../controller/ProductController';
import { CurrentStoreContext } from '../../../controller/StoreController';
import { useToast } from '../../../controller/ToastController';
import SetItemGuideModal from '../../../components/modal/SetItemGuideModal';

const numList: any = [];
for (let i = 1; i < 11; i++) {
  numList.push({
    key: i,
    value: i,
    name: `${i}개`,
    label: `${i}개`,
  });
}

const SetItemEdit = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const location = useLocation();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const setItemInfo: SetMenuItemType = location.state?.setItemInfo;
  const [name, setName] = useState<string>('');
  const [productList, setProductList] = useState<SetItemProductType[]>([]);
  const [itemType, setItemType] = useState<number>(0);

  const [keyword, setKeyword] = useState<string>('');
  const [allProductList, setAllProductList] = useState<ProductType[]>([]);
  const [searchedList, setSearchedList] = useState<ProductType[]>([]);

  const [min, setMin] = useState({
    key: -1,
    value: -1,
    name: '필수 선택수를 선택해주세요',
    label: `필수 선택수를 선택해주세요`,
  });
  const [max, setMax] = useState({
    key: -1,
    value: -1,
    name: '최대 선택수를 선택해주세요',
    label: `최대 선택수를 선택해주세요`,
  });

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [visibleSetItemGuide, setVisibleSetItemGuide] = useState<boolean>(false);

  // 필수 확인
  const checkRequired = () => {
    if (
      name.length > 0 &&
      productList.length > 0 &&
      max.value > 0 &&
      min.value <= productList.length &&
      max.value <= productList.length
    )
      return true;
    return false;
  };

  // 단위 변환
  const getPrice = (value: string) => {
    return value.replace(/[^0-9]/g, '');
  };
  const getPriceNrm = (value: number) => {
    return `${value > 0 ? '+' : ''}${value.toLocaleString()}원`;
  };

  const onChange_ItemType = (value: number) => {
    setItemType(value);
    if (value === 0) {
      setMin({
        key: 1,
        value: 1,
        name: `1개`,
        label: `1개`,
      });
      setMax({
        key: 1,
        value: 1,
        name: `1개`,
        label: `1개`,
      });
    } else {
      setMin({
        key: 0,
        value: 0,
        name: `선택안함`,
        label: `선택안함`,
      });
      setMax({
        key: 1,
        value: 1,
        name: `1개`,
        label: `1개`,
      });
    }
  };

  // 검색
  const getSearchResult = () => {
    setSearchedList(allProductList.filter((item) => item.prd_name.includes(keyword)));
  };

  // 상품 추가
  const addProductList = (prd_id: number) => {
    if (!productList.some((item) => item.prd_id === prd_id)) {
      const selectedProduct = allProductList.find((item) => item.prd_id === prd_id);
      if (selectedProduct) {
        const productTemp: SetItemProductType = Object.assign(selectedProduct, { price: 0 });
        setProductList([...productList, productTemp]);
      }
    } else {
      showToast('이미 등록된 상품이에요', 'error');
    }
  };
  const deleteProductList = (index: number) => {
    productList.splice(index, 1);
    setProductList([...productList]);
  };

  // change
  const onChange_name = (event: any) => {
    setName(event.target.value);
  };
  const onChange_min = (event: any) => {
    setMin(event);
    setMax(event);
  };
  const onChange_max = (event: any) => {
    setMin({
      key: 0,
      value: 0,
      name: `선택안함`,
      label: `선택안함`,
    });
    setMax(event);
  };
  const update_productList = (priceNrm: string, index: number) => {
    let listTemp = productList;
    listTemp[index].price = parseInt(getPrice(priceNrm));
    console.log('listTemp', listTemp);
    setProductList([...listTemp]);
  };

  // API 호출
  const setSetItemData = async () => {
    try {
      if (checkRequired()) {
        //
        if (setItemInfo) {
          let setItemPrdTemp: any = [];
          productList.map((item: SetItemProductType) => {
            setItemPrdTemp.push({ product_id: item.prd_id, price: item.price });
          });

          const setItem: any = {
            set_type_id: setItemInfo.set_type_id,
            set_type_name: name,
            input_min: min.value,
            input_max: max.value,
            product_list: setItemPrdTemp,
          };
          const oRes = await ProductController.editSetPrdGroup(currentStore.value, setItem);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('editSetPrdGroup', oResponse);
            if (oResponse.data && oResponse.ok) {
              // console.log(productTemp);
              showToast('새로운 세트상품 정보를 등록했어요');
            }
          }
        } else {
          let setItemPrdTemp: any = [];
          productList.map((item: SetItemProductType) => {
            setItemPrdTemp.push({ product_id: item.prd_id, price: item.price });
          });

          const setItem: any = {
            name: name,
            input_min: min.value,
            input_max: max.value,
            product_list: setItemPrdTemp,
          };
          const oRes = await ProductController.setSetPrdGroup(currentStore.value, setItem);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('setSetPrdGroup', oResponse);
            if (oResponse.data && oResponse.ok) {
              // console.log(productTemp);
              showToast('새로운 세트상품 정보를 등록했어요');
              navigate(-1);
            }
          }
        }
      } else {
        if (min.value > productList.length || max.value > productList.length)
          showToast('선택수가 상품 개수보다 많아요', 'error');
        else showToast('필수 정보를 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const deleteSetItemData = async () => {
    try {
      const oRes = await ProductController.delSetPrdGroup(setItemInfo.set_type_id!);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('delSetPrdGroup', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('세트상품을 삭제했어요');
          navigate(-1);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getAllProductList = async () => {
    try {
      const oRes = await ProductController.getAllProductList(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllProductList', oResponse);
        if (oResponse.data) {
          setAllProductList([...oResponse.data]);
          setSearchedList([...oResponse.data]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getAllProductList();
  }, []);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > productList.length - 1) toIndex = productList.length;
    const newItems = [...productList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setProductList(newItems);
  };

  interface DraggableItemProps {
    item: SetItemProductType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderPreviewItem = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);
    const [priceNrm, setPriceNrm] = useState<string>(
      `${item.price > 0 ? '+' : ''}${item.price.toLocaleString()}원`,
    );

    const onChange_price = (e: any) => {
      setPriceNrm(e.target.value);
    };

    const onBlurInput = () => {
      update_productList(getPriceNrm(parseInt(priceNrm)), index);
    };

    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });
    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    return (
      <div className="menuItem" key={index}>
        <div className="row gap">
          <input
            ref={(node) => drag(drop(node))}
            value={selectedIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveItem(index, selectedIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveItem(index, selectedIndex - 1);
              }
            }}
          />
          <h4>{item.prd_name}</h4>
        </div>
        <div className="row">
          <input
            className="priceInput"
            value={priceNrm}
            onChange={onChange_price}
            onFocus={() => setPriceNrm(getPrice(priceNrm))}
            onBlur={onBlurInput}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onBlurInput();
              }
            }}
          />

          <button className="addButton" onClick={() => deleteProductList(index)}>
            삭제
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    console.log('setItemInfo', setItemInfo);
    if (setItemInfo) {
      setName(setItemInfo.set_type_name);
      setMin({
        key: setItemInfo.input_min,
        value: setItemInfo.input_min,
        name: `${setItemInfo.input_min}개`,
        label: `${setItemInfo.input_min}개`,
      });
      setMax({
        key: setItemInfo.input_max,
        value: setItemInfo.input_max,
        name: `${setItemInfo.input_max}개`,
        label: `${setItemInfo.input_max}개`,
      });
      setItemType(setItemInfo.input_min === 0 ? 1 : 0);
      setProductList([...setItemInfo.product_list]);
    }
  }, []);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="editHeaderWrap">
            <button className="backButton" onClick={() => navigate(-1)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
            </button>
            {setItemInfo ? (
              <button className="deleteButton" onClick={() => setVisibleConfirm(true)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_green.svg`} alt="ic" />
                <h5>세트상품 삭제</h5>
              </button>
            ) : (
              <div />
              // <button className="guideButton" onClick={() => setVisibleSetItemGuide(true)}>
              //   <h4>세트메뉴 만드는 방법</h4>
              // </button>
            )}
          </div>

          <div className="inputText">
            <div className="title">
              <h4>세트구성명</h4>
              <h5>(필수)</h5>
            </div>
            <input
              type="text"
              placeholder="고객에게 요청하는 이름으로 적어주세요  ex) 피자 1개를 선택해주세요"
              value={name}
              onChange={onChange_name}
            />
          </div>
          <div className="inputText">
            <div className="title nonePadding">
              <h4>세트/옵션 선택</h4>
              <h5>(필수)</h5>
            </div>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <div>
                <p>
                  세트구성: 필수로 최소 1개는 선택해야 하는 구성 <span>예)피자, 파스타</span>
                </p>
                <p>
                  옵션구성: 필수가 아님 <span>예) 음료, 사이드</span>
                </p>
              </div>
            </div>
            <div className="selectBoxWrap">
              <div
                className={`selectBox left ${itemType === 0 && 'active'}`}
                onClick={() => onChange_ItemType(0)}>
                세트 구성
              </div>
              <div
                className={`selectBox right ${itemType === 1 && 'active'}`}
                onClick={() => onChange_ItemType(1)}>
                옵션 구성
              </div>
            </div>
            {itemType === 0 ? (
              <div className="inputText">
                <div className="title initial">
                  <h5 className="title">필수 선택수</h5>
                </div>
                <DropdownSelect options={numList} defaultValue={min} onChangeValue={onChange_min} />
              </div>
            ) : (
              <div className="inputText">
                <div className="title initial">
                  <h5 className="title">최대 선택수</h5>
                </div>
                <DropdownSelect options={numList} defaultValue={max} onChangeValue={onChange_max} />
              </div>
            )}
          </div>
          <div className="inputText">
            <div className="title">
              <h4>상품추가</h4>
            </div>
            <div className="search">
              <input
                type="text"
                value={keyword}
                placeholder="추가하실 상품명을 검색해주세요"
                autoFocus={false}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    getSearchResult();
                  }
                }}
              />
              <button className="searchBox" onClick={getSearchResult}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search_grey.svg`} alt="search" />
              </button>
              <div className="searchedList">
                {searchedList.map((item: ProductType, index: number) => {
                  return (
                    <div key={index} className="searchedItem">
                      <h4>{item.prd_name}</h4>
                      <button className="addButton" onClick={() => addProductList(item.prd_id)}>
                        추가
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>세트구성 미리보기</h4>
            </div>
            <div className="listItem">
              <div className="row gap">
                <div className="indexBox">1</div>
                <h3>{name}</h3>
              </div>
              <div className="row gap">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="ic" />
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey.svg`}
                  width={30}
                  height={30}
                  alt="ic"
                />
              </div>
            </div>
            {productList.length > 0 && (
              <DndProvider backend={HTML5Backend}>
                <div className="menuList">
                  {productList.map((item: SetItemProductType, index: number) => {
                    return (
                      <RenderPreviewItem
                        key={index}
                        item={item}
                        index={index}
                        moveItem={moveItem}
                      />
                    );
                  })}
                </div>
              </DndProvider>
            )}
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
            </div>
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={setSetItemData}>
            저장
          </button>
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={deleteSetItemData}
      />
      <SetItemGuideModal isVisible={visibleSetItemGuide} setVisible={setVisibleSetItemGuide} />
    </>
  );
};

export default SetItemEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .editHeaderWrap {
    margin-left: -50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
    .guideButton {
      display: flex;
      align-items: center;
      padding: 6px 32px;
      background: #ff6060;
      border: 1px solid #ff6060;
      border-radius: 5px;
      h4 {
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
      }
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding: 6px 0 10px 0;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .inputText {
    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5.title {
        color: #555555;
        font-weight: 400;
        padding: 0;
      }

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .imageSpan {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
    .title.nonePadding {
      padding-bottom: 0;
    }
  }

  .search {
    width: 100%;
    position: relative;

    input {
      border-radius: 5px 5px 0 0;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-weight: 400;
      padding: 10px 24px;
    }
    .searchBox {
      top: 0;
      padding: 8px 0;
      position: absolute;
      display: flex;
      align-items: center;
      cursor: pointer;
      right: 14px;
    }
    .searchedList {
      height: 200px;
      border-radius: 0 0 5px 5px;
      border: 1px solid #cecece;
      border-top: none;
      overflow-y: auto;
      .searchedItem {
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 20px;
        border-bottom: 1px solid #f7f7f7;
        h4 {
          color: #555555;
        }
      }
    }
  }
  .addButton {
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    color: #4dd2ae;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    padding: 4px 10px;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }

  input::placeholder {
    color: #cecece;
  }

  .selectItem {
    text-align: left;
  }

  .listItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px 10px 22px;
    background: #ecf5f3;
    border: 1px solid #ecf5f3;
    border-radius: 5px 5px 0 0;

    .indexBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      padding: 4px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      text-align: center;
      color: #979797;
      background: #ecf5f3;
      border: 1px solid #cecece;
      border-radius: 4px;
    }
    .row {
      gap: 6px;
    }
    .row.gap {
      gap: 14px;
      align-items: center;
    }
  }

  .menuList {
    display: flex;
    flex-direction: column;
    border: 1px solid #e5e5e5;
    border-top: none;
    border-radius: 0 0 5px 5px;
    .menuItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 20px;
      border-bottom: 1px solid #f7f7f7;
      input {
        width: 24px;
        height: 24px;
        padding: 4px;
        font-size: 14px;
        line-height: 16px;
        font-weight: 600;
        text-align: center;
        color: #555555;
        background: #ffffff;
        border: 1px solid #4dd2ae;
        border-radius: 4px;
      }

      .column {
        gap: 2px;
      }
      h4 {
        color: #555555;
        font-weight: 500;
      }
      h5 {
        color: #555555;
        font-weight: 400;
      }
      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }

      .priceInput {
        width: 120px;
        height: auto;
        background: #ffffff;
        color: #979797;
        border: 1px solid #cecece;
        font-size: 16px;
        line-height: 18px;
        font-weight: 500;
        padding: 4px 10px;
        text-align: right;
      }
    }
  }
`;
